import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import SettingsTabNav from './SettingsTabNav';
import CommunityDescribePrompt from './CommunityDescribePrompt';
import CommunityLivePreview from './CommunityLivePreview';
import { PortalPageHeader } from '../layout/PortalPageHeader';
import { SETTINGS_TAB_IDS } from './settingsTabs';
import { shouldShowCompanyDescribePrompt } from './PartnerSettingsSection/companyInfoDefaults';
import { usePartnerCompanyInfoQuery } from '../../api/use-partner-company-info-query';
import CompanyInfo from './PartnerSettingsSection/CompanyInfo';
import Security from './PartnerSettingsSection/Security';
import PrivacyNotice from './PartnerSettingsSection/PrivacyNotice';
import TermsAndConditions from './PartnerSettingsSection/TermsAndConditions';

const renderSettingsPanel = (activeTab, companyPanelProps) => {
  if (activeTab === SETTINGS_TAB_IDS.COMPANY_INFO) {
    return <CompanyInfo {...companyPanelProps} />;
  }

  if (activeTab === SETTINGS_TAB_IDS.SECURITY) {
    return <Security />;
  }

  if (activeTab === SETTINGS_TAB_IDS.PRIVACY_NOTICE) {
    return <PrivacyNotice />;
  }

  if (activeTab === SETTINGS_TAB_IDS.TERMS_AND_CONDITIONS) {
    return <TermsAndConditions />;
  }

  return null;
};

const PartnerSettings = () => {
  const [activeTab, setActiveTab] = useState(SETTINGS_TAB_IDS.COMPANY_INFO);
  const [companyPreview, setCompanyPreview] = useState(null);
  const [generatedPatch, setGeneratedPatch] = useState(null);
  const { data: partnerUser } = usePartnerCompanyInfoQuery();
  const isCompanyTab = activeTab === SETTINGS_TAB_IDS.COMPANY_INFO;
  const showDescribePrompt = isCompanyTab && shouldShowCompanyDescribePrompt(partnerUser);

  const handleGeneratedConsumed = useCallback(() => {
    setGeneratedPatch(null);
  }, []);

  return (
    <Box>
      <PortalPageHeader title="Settings" />

      {showDescribePrompt ? <CommunityDescribePrompt onApply={setGeneratedPatch} /> : null}

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: { xs: 'stretch', lg: 'flex-start' },
          gap: 3,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: '0 1px 3px rgba(0,0,0,.04)',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            overflow: 'hidden',
          }}
        >
          <SettingsTabNav activeTab={activeTab} onTabChange={setActiveTab} />
          <Box sx={{ flex: 1, minWidth: 0, p: { xs: 2.5, md: '28px 36px 40px' } }}>
            {renderSettingsPanel(activeTab, {
              generatedPatch,
              onGeneratedConsumed: handleGeneratedConsumed,
              onLiveChange: setCompanyPreview,
            })}
          </Box>
        </Box>

        {isCompanyTab ? (
          <CommunityLivePreview form={companyPreview} stats={partnerUser?.stats} />
        ) : null}
      </Box>
    </Box>
  );
};

export default PartnerSettings;
